import { Check, Clock, ShieldCheck, XCircle } from "lucide-react";

export function CoachApprovalPanel({ r, canApprove, canReject, busy, onApprove, onReject }) {
  const teams = [[r.from_team_id, r.from_team_name, r.from_team_age_group], [r.team_id, r.team_name, r.team_age_group]];
  const approvals = r.approvals || {};
  const waiting = r.stage === "coach_approval" && r.status === "active";
  return (
    <div className="mt-3 rounded-md border border-border bg-muted/30 p-3" data-testid={`reg-approvals-${r.id}`}>
      <div className="text-[10px] tracking-widest uppercase opacity-60 inline-flex items-center gap-1"><ShieldCheck className="w-3 h-3" /> Coach approvals · {r.reg_type_label}</div>
      <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-2">
        {teams.map(([tid, name, age], i) => {
          const a = approvals[tid];
          return (
            <div key={tid || i} className={`rounded border px-3 py-2 text-xs flex items-start gap-2 ${a ? "border-[#83B68B]/50 bg-[#83B68B]/10" : "border-amber-400/40 bg-amber-500/5"}`} data-testid={`reg-approval-${r.id}-${i === 0 ? "from" : "to"}`}>
              {a ? <Check className="w-3.5 h-3.5 text-[#83B68B] mt-0.5" /> : <Clock className="w-3.5 h-3.5 text-amber-300 mt-0.5" />}
              <div className="min-w-0">
                <div className="font-semibold">{i === 0 ? "From" : "To"}: {age} · {name}</div>
                <div className="opacity-70">{a ? `Approved by ${a.by_name}` : "Awaiting head coach"}</div>
              </div>
            </div>
          );
        })}
      </div>
      {waiting && (canApprove || canReject) && (
        <div className="mt-3 flex flex-wrap gap-2">
          {canApprove && <button type="button" disabled={busy} onClick={onApprove} className="btn-volt text-[10px] tracking-widest uppercase px-3 py-1.5 rounded inline-flex items-center gap-1" data-testid={`reg-coach-approve-${r.id}`}><Check className="w-3 h-3" /> Approve {r.reg_type_label.toLowerCase()}</button>}
          {canReject && <button type="button" disabled={busy} onClick={onReject} className="text-[10px] tracking-widest uppercase px-3 py-1.5 rounded border border-red-400/40 text-red-300 hover:bg-red-500/10 inline-flex items-center gap-1" data-testid={`reg-coach-reject-${r.id}`}><XCircle className="w-3 h-3" /> Reject</button>}
        </div>
      )}
    </div>
  );
}
